import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type EditPersonalProfileDialogViewModel } from '@/features/jobs/info-gathering/individual-info/components/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import { type SpousalProfileViewModel } from '@/features/jobs/info-gathering/individual-info/SpousalProfileViewModel'
import { SpousalProfile } from '@/features/jobs/info-gathering/individual-info/components/SpousalProfile'

export interface SpousalProfileContainerProps {
  vm: SpousalProfileViewModel
  editVm: EditPersonalProfileDialogViewModel | null
}

export const SpousalProfileContainer = observer(
  function SpousalProfileContainer({
    vm,
    editVm,
  }: SpousalProfileContainerProps) {
    const profile = vm.profile
    if (!vm.item.completed) {
      return null
    }

    const renderProfile = (isLoading: boolean) => (
      <SpousalProfile
        isLoading={isLoading}
        isEditable={!!editVm?.canShow}
        onEdit={editVm?.showSpousal}
        fullName={vm.fullName}
        dateOfBirth={vm.dateOfBirth}
        occupation={profile?.occupation}
        email={profile?.contactInfo.email}
        personalTaxpayerIdentificationNumber={
          profile?.personalInfo.personalTaxpayerIdentificationNumber
        }
        maskedPersonalTaxpayerIdentificationNumber={
          vm.maskedPersonalTaxpayerIdentificationNumber
        }
        editButtonTestId="update-spousal-information-button"
      />
    )

    return vm.fetch.match({
      pending: () => renderProfile(true),
      rejected: (err) => <ContentError error={err} />,
      resolved: () => renderProfile(false),
    })
  },
)
